<template>
    <div>
        <div class="form-group">
            <label>Authorization Token</label>
            <input type="text" class="form-control" v-model="data.authorizationToken">
        </div>
        <div class="form-group">
            <label>Lead Source</label>
            <input type="text" class="form-control" v-model="data.leadSource" placeholder="TruckersReport Paid Legal">
        </div>
        <div class="form-group">
            <label>Target URL (optional, defaults to production)</label>
            <input type="text" class="form-control" v-model="data.targetUrl" placeholder="https://truckingfeeds.com/api/v1/applications/shortform">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
